"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.delete.confirm.title': 'Elimina Passo',
    'step.delete.confirm.message': 'Sei sicuro di voler eliminare questo passo?',
};
